/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Review_AllInputs */



/**
* | output |
* | --- |
* | "Publishing review results for all tracks." |
*
* @param {Work_Order_Publish_Status_Review_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_review_all = /** @type {((inputs?: Work_Order_Publish_Status_Review_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Review_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication des résultats de révision pour toutes les pistes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichung der Rezensionen für alle Titel.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione dei risultati delle recensioni per tutte le tracce.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты рецензирования публикаций по всем направлениям.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación de resultados de revisión para todas las pistas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布所有赛道的评审结果。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("全トラックのレビュー結果を公開します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी ट्रैक के लिए समीक्षा परिणाम प्रकाशित किए जा रहे हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicando os resultados das avaliações para todas as faixas.")
	return /** @type {LocalizedString} */ ("Publishing review results for all tracks.")
});